import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalculationResult, ToolOutput } from '../../../models/calculationModels';
import { Router } from '@angular/router';

@Component({
    selector: 'app-bolt-and-pump-output',
    templateUrl: './bolt-and-pump-output.component.html',
    styleUrls: ['./bolt-and-pump-output.component.scss'],
    standalone: false
})
export class BoltAndPumpOutputComponent {
    @Input() calcOutput: CalculationResult;
    @Input() selectedTool: ToolOutput;
    @Output() showAdvOptPanel: EventEmitter<true> = new EventEmitter();
    @Input() displayIDMSSettings: boolean;
    constructor(public router: Router) {}
    showAdvancedOutputpanel() {
        this.showAdvOptPanel.emit(true);
    }
}
